// Polyfills
// import 'es6-promise/auto'
// import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { fetchSession } from 'sociolla-analytics/actions/session';
import App from './App';
import store from './store';
import router from './router';
import customConfig from './config';
// import './i18n'
import './filter';
import '@/assets/sass/style.scss';
import '@/shared/RegisteredGlobalComponents';
import axios from 'axios';
import VueCarousel from 'vue-carousel';
import '@/shared/socio-lib';
import Toasted from 'vue-toasted';
import Swiper from 'swiper';
import VueClipboard from 'vue-clipboard2';
import InfiniteLoading from 'vue-infinite-loading';
// import Vuebar from 'vuebar'
import VTooltip from 'v-tooltip';
import OtpInput from '@bachdgvn/vue-otp-input';
import interceptorsSetup from './shared/interceptors';
import Croppa from 'vue-croppa';
import VueRecaptcha from 'vue-recaptcha';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/id';
const upperCase = require('lodash.uppercase');
const startCase = require('lodash.startcase');
const Config = require('../config/default.env').default;

Vue.component('v-otp-input', OtpInput);
Vue.component('VueRecaptcha', {
  extends: VueRecaptcha,
  props: {
    sitekey: {
      type: String,
      default: () => Config.RECAPTCHA_SITE_KEY,
    },
    loadRecaptchaScript: {
      type: Boolean,
      default: () => true,
    },
  },
});

Vue.use(VTooltip);
// Vue.use(Vuebar)
Vue.use(VueCarousel);
Vue.use(VueClipboard);
Vue.use(InfiniteLoading);
Vue.use(Croppa);

window.Vue = Vue;
window.axios = axios;
window.Swiper = Swiper;
window.$SO = $SO;
Vue.prototype.$SO = $SO;
Vue.prototype.$upperCase = upperCase;
Vue.prototype.$startCase = startCase;
Vue.prototype.$customConfig = customConfig;

axios.defaults.withCredentials = true;

Vue.directive('scroll', {
  inserted: function (el, binding) {
    const f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});

interceptorsSetup();

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.tz.setDefault('Asia/Jakarta');
dayjs.locale('id');
dayjs.updateLocale('id', {
  relativeTime: {
    future: '%s',
    past: '%s',
    s: 'Sekarang',
    m: '1 menit',
    mm: '%d menit',
    h: '1 jam',
    hh: '%d jam',
    d: '1 hari',
    dd: '%d hari',
    M: '1 bulan',
    MM: '%d bulan',
    y: '1 tahun',
    yy: '%d tahun',
  },
});
window.dayjs = dayjs;

// use httpJournal globaly to call Journal w/ credentials
const httpMsBjPublicApiUrl = axios.create({
  baseURL: Config.MS_BJ_PUBLIC_API_URL,
  // withCredentials: true,
});

// use httpSOCO globaly to call SOCO w/ credentials
const httpMsSocoPublicApiUrl = axios.create({
  baseURL: Config.MS_SOCO_PUBLIC_API_URL,
  // withCredentials: true,
});
const httpMsReviewApiUrl = axios.create({
  baseURL: Config.MS_REVIEW_API_URL,
  // withCredentials: true,
});
const httpMsOrderApiUrl = axios.create({
  baseURL: Config.MS_ORDER_API_URL,
  // withCredentials: true,
});
const httpMsCatalogApiUrl = axios.create({
  baseURL: Config.MS_CATALOG_API_URL,
  // withCredentials: true,
});
const headers = {};
headers['session_id'] = fetchSession();
const httpMsAnalyticsApiUrl = axios.create({
  baseURL: Config.MS_ANALYTICS_API_URL,
  headers,
});

let lastUsedDomainSocoPublicApi = 0;
let lastUsedDomainBjPublicApi = 0;
let lastUsedDomainCatalogApi = 0;

httpMsBjPublicApiUrl.interceptors.request.use(
  (config) => {
    config.headers['SOC-PLATFORM'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile';
    if (store.state.auth.token && store.state.auth.loggedin) {
      config.headers.Authorization = `Bearer ${store.state.auth.token}`;
    }

    if (config.url.startsWith(Config.MS_BJ_PUBLIC_API_URL)) {
      config.url =
        Config.MS_BJ_PUBLIC_API_LIST[lastUsedDomainBjPublicApi] + config.url.substr(Config.MS_BJ_PUBLIC_API_URL.length);
      lastUsedDomainBjPublicApi =
        lastUsedDomainBjPublicApi + 1 >= Config.MS_BJ_PUBLIC_API_LIST.length ? 0 : lastUsedDomainBjPublicApi + 1;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
httpMsSocoPublicApiUrl.interceptors.request.use(
  (config) => {
    config.headers['SOC-PLATFORM'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile';
    if (store.state.auth.token && store.state.auth.loggedin) {
      config.headers.Authorization = `Bearer ${store.state.auth.token}`;
    }

    if (config.url.startsWith(Config.MS_SOCO_PUBLIC_API_URL)) {
      config.url =
        Config.MS_SOCO_PUBLIC_API_LIST[lastUsedDomainSocoPublicApi] +
        config.url.substr(Config.MS_SOCO_PUBLIC_API_URL.length);
      lastUsedDomainSocoPublicApi =
        lastUsedDomainSocoPublicApi + 1 >= Config.MS_SOCO_PUBLIC_API_LIST.length ? 0 : lastUsedDomainSocoPublicApi + 1;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
httpMsReviewApiUrl.interceptors.request.use(
  (config) => {
    config.headers['SOC-PLATFORM'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile';
    if (store.state.auth.token && store.state.auth.loggedin) {
      config.headers.Authorization = `Bearer ${store.state.auth.token}`;
    }

    if (config.url.startsWith(Config.MS_REVIEW_API_URL)) {
      config.url =
        Config.MS_REVIEW_API_URL[lastUsedDomainReviewApi] + config.url.substr(Config.MS_REVIEW_API_URL.length);
      lastUsedDomainReviewApi =
        lastUsedDomainReviewApi + 1 >= Config.MS_REVIEW_API_URL.length ? 0 : lastUsedDomainReviewApi + 1;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
httpMsOrderApiUrl.interceptors.request.use(
  (config) => {
    config.headers['SOC-PLATFORM'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile';
    if (store.state.auth.token && store.state.auth.loggedin) {
      config.headers.Authorization = `Bearer ${store.state.auth.token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
httpMsCatalogApiUrl.interceptors.request.use(
  (config) => {
    config.headers['SOC-PLATFORM'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile';
    if (store.state.auth.token && store.state.auth.loggedin) {
      config.headers.Authorization = `Bearer ${store.state.auth.token}`;
    }

    if (config.url.startsWith(Config.MS_CATALOG_API_URL)) {
      config.url =
        Config.MS_CATALOG_API_LIST[lastUsedDomainCatalogApi] + config.url.substr(Config.MS_CATALOG_API_URL.length);
      lastUsedDomainCatalogApi =
        lastUsedDomainCatalogApi + 1 >= Config.MS_CATALOG_API_LIST.length ? 0 : lastUsedDomainCatalogApi + 1;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
httpMsAnalyticsApiUrl.interceptors.request.use(
  (config) => {
    config.headers['SOC-PLATFORM'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile';
    if (store.state.auth.token && store.state.auth.loggedin) {
      config.headers.Authorization = `Bearer ${store.state.auth.token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
Vue.prototype.$MS_BJ_PUBLIC_API_URL = httpMsBjPublicApiUrl;
Vue.prototype.$MS_SOCO_PUBLIC_API_URL = httpMsSocoPublicApiUrl;
Vue.prototype.$MS_REVIEW_API_URL = httpMsReviewApiUrl;
Vue.prototype.$MS_ORDER_API_URL = httpMsOrderApiUrl;
Vue.prototype.$MS_CATALOG_API_URL = httpMsCatalogApiUrl;
Vue.prototype.$MS_ANALYTICS_API_URL = httpMsAnalyticsApiUrl;
// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {
  fieldsBagName: 'formFields',
});

const dict = {
  messages: {
    required: (field) => 'Data belum diisi',
  },
  custom: {
    firstname: {
      required: () => 'Nama Depan belum diisi',
      alpha_dash: () => 'Data tidak boleh menggunakan karakter spesial',
      alpha_spaces: () => 'Nama Depan hanya boleh menggunakan alphabet',
      min: () => 'Nama Depan minimal 1 karakter',
      max: () => 'Nama Depan maksimal 32 karakter',
    },
    lastname: {
      required: () => 'Nama Belakang belum diisi',
      alpha_dash: () => 'Data tidak boleh menggunakan karakter spesial',
      alpha_spaces: () => 'Nama Belakang hanya boleh menggunakan alphabet',
      min: () => 'Nama Belakang minimal 1 karakter',
      max: () => 'Nama Belakang maksimal 32 karakter',
    },
    username: {
      required: () => 'Username belum diisi',
      alpha_dash: () => 'Username tidak boleh menggunakan karakter spesial',
    },
    hp: {
      required: () => 'Nomor Handphone belum diisi',
      numeric: () => 'Nomor Handphone hanya boleh menggunakan angka',
      min: () => 'Nomor Handphone minimal 10 angka',
      max: () => 'Nomor Handphone maksimal 14 angka',
    },
    regusername: {
      required: () => 'Username belum diisi',
      alpha_dash: () => 'Username tidak boleh menggunakan karakter spesial',
      min: () => 'Username minimal 4 karakter',
      max: () => 'Username maksimal 16 karakter',
    },
    email: {
      required: () => 'Email belum diisi',
      email: () => 'Email tidak valid',
    },
    forgotemail: {
      required: () => 'Email belum diisi',
      email: () => 'Email tidak valid',
    },
    forgothp: {
      required: () => 'Nomor Handphone belum diisi',
      numeric: () => 'Nomor Handphone hanya boleh menggunakan angka',
      min: () => 'Nomor Handphone minimal 10 angka',
      max: () => 'Nomor Handphone maksimal 14 angka',
    },
    minhp: {
      required: () => 'Data not filled in',
      numeric: () => 'Phone number can only use numbers',
      min: () => 'Phone number must consists 7 - 14 number',
      max: () => 'Phone number must consists 7 - 14 number',
    },
    password: {
      required: () => 'Password belum diisi',
    },
    repassword: {
      required: () => 'Konfirmasi password belum diisi',
      confirmed: () => 'Konfirmasi password tidak sesuai',
      min: () => 'Password minimal 6 karakter',
      max: () => 'Password maksimal 60 karakter',
    },
    regpassword: {
      required: () => 'Password belum diisi',
      confirmed: () => 'Password tidak sesuai',
      min: () => 'Password minimal 6 karakter',
      max: () => 'Password maksimal 60 karakter',
    },
    newpassword: {
      required: () => 'Password belum diisi',
    },
    newPassword: {
      required: () => 'Password belum diisi',
      confirmed: () => 'Konfirmasi password tidak sesuai',
    },
    confirmPassword: {
      required: () => 'Konfirmasi password belum diisi',
      confirmed: () => 'Konfirmasi password tidak sesuai',
    },
    confirmnewpassword: {
      required: () => 'Password belum diisi',
      confirmed: () => 'Password tidak sesuai',
      min: () => 'Password minimal 6 karakter',
      max: () => 'Password maksimal 60 karakter',
    },
    'brand name': {
      required: () => 'Brand Name belum diisi',
      min: () => 'Brand Name minimal 3 karakter',
    },
    'product name': {
      required: () => 'Product Name belum diisi',
      min: () => 'Product Name minimal 3 karakter',
    },
    category: {
      required: () => 'Kategori belum diisi',
    },
    subcategory1: {
      required: () => 'Subkategori 1 belum diisi',
    },
    subcategory2: {
      required: () => 'Subkategori 2 belum diisi',
    },
    content_review: {
      required: () => 'Review belum diisi',
      min: () => 'Review minimal 150 karakter',
    },
  },
};
VeeValidate.Validator.localize('en', dict);

const customToastOpt = {
  position: 'top-center',
  singleton: true,
  duration: 3333,
  keepOnHover: true,
  action: {
    text: '×',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    },
  },
};

Vue.use(Toasted, customToastOpt);

Vue.toasted.register(
  'error',
  (payload) => {
    if (!Object.keys(payload).length) {
      return `
          <div class="toast-icon error">
              <i class="icon_error-circle_alt"></i>
          </div>
          <div class="toast-message">
            Error
          </div>`;
    }

    if (!!payload.message) {
      return `
          <div class="toast-icon error">
              <i class="icon_error-circle_alt"></i>
          </div>
          <div class="toast-message">
            ${payload.message}
          </div>`;
    }
    if (typeof payload === 'string') {
      return `
          <div class="toast-icon error">
              <i class="icon_error-circle_alt"></i>
          </div>
          <div class="toast-message">
            ${payload}
          </div>`;
    }
  },
  customToastOpt
);
Vue.toasted.register(
  'show',
  (payload) => {
    if (!Object.keys(payload).length) {
      return `
          <div class="toast-icon">
              <i class="icon_check_alt2"></i>
          </div>
          <div class="toast-message">
            Error
          </div>`;
    }

    if (typeof payload === 'object') {
      return `
          <div class="toast-icon">
              <i class="icon_check_alt2"></i>
          </div>
          <div class="toast-message ${payload.classNameForMessage}">
            ${payload.message}
          </div>`;
    }
    if (typeof payload === 'string') {
      return `
          <div class="toast-icon">
              <i class="icon_check_alt2"></i>
          </div>
          <div class="toast-message">
            ${payload}
          </div>`;
    }
  },
  customToastOpt
);
Vue.toasted.register(
  'notif',
  (payload) => {
    if (!Object.keys(payload).length) {
      return `
          <div class="toast-icon">
              <i class="icon_check_alt2"></i>
          </div>
          <div class="toast-message">
            Error
          </div>`;
    }

    if (!!payload.message) {
      return `
          <div class="toast-icon">
              <i class="icon_check_alt2"></i>
          </div>
          <div class="toast-message">
            ${payload.message}
          </div>`;
    }
    if (typeof payload === 'string') {
      return `
          <div class="toast-icon">
              <img src="/assets/img/icon-notif.svg" alt="icon-notif"/>
          </div>
          <div class="toast-message">
            ${payload}
          </div>`;
    }
  },
  { ...customToastOpt, type: 'info' }
);

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});
